import { io, Socket } from 'socket.io-client';

const SOCKET_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

// Define auth type
type SocketAuth = {
  token: string | null;
};

// Create socket instance
export const socket = io(SOCKET_URL, {
  autoConnect: false,
  path: '/socket.io',
  auth: {
    token: localStorage.getItem('token')
  } as SocketAuth,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000
}) as Socket<{}, SocketAuth>;

// Socket event handlers
socket.on('connect_error', (error) => {
  console.error('Socket connection error:', error);
  if (error.message === 'Authentication error') {
    localStorage.removeItem('token');
    window.location.href = '/login';
  }
});

socket.on('connect', () => {
  const auth = socket.auth as SocketAuth;
  console.log('Socket connected successfully:', {
    id: socket.id,
    hasToken: !!auth.token
  });
});

socket.on('disconnect', (reason) => {
  console.log('Socket disconnected:', {
    reason,
    wasConnected: socket.connected
  });
});

export const connectSocket = () => {
  if (!socket.connected) {
    const token = localStorage.getItem('token');
    const auth = { token } as SocketAuth;
    
    console.log('Connecting to socket server...', {
      hasToken: !!token,
      currentAuth: socket.auth
    });
    
    // Update auth token before connecting
    socket.auth = auth;
    socket.connect();
  }
};

export const disconnectSocket = () => {
  if (socket.connected) {
    console.log('Disconnecting from socket server...');
    socket.disconnect();
  }
}; 